import { useEffect } from "react";

import { Gift } from "lucide-react";

import { CompraItem } from "shared/components/compraitem/CompraItem";

import PageContainer from "shared/components/pagecontainer/PageContainer";

import { useCompras } from "shared/hooks/useCompras";

import styles from "./MinhasCompras.module.scss";

export const MinhasCompras: React.FC = () => {
  const {
    compras,
    loading,
    vazio,
    carregarCompras,
  } = useCompras();

  useEffect(() => {
    carregarCompras();
  }, [carregarCompras]);

  if (loading) {
    return (
      <PageContainer title="Minhas Compras" showDesktopSearch={false} showLogo
        logo={ <img src="/imagens/menuLogoBranco.png" alt="Move"/>
        }
      >
        <p>Carregando...</p>
      </PageContainer>
    );
  }

  return (
    <PageContainer title="Minhas Compras" icon={<Gift size={18}/>} showDesktopSearch={false}
      showLogo logo={<img src="/imagens/menuLogoBranco.png" alt="Move"/>}>
      <div className={styles.gridContainer}>
        {vazio ? (
          <div className={styles.comprasVazio}>
            <Gift size={40} />

            <p className={styles.fraseVazio}>
              Você ainda não tem nenhuma compra
            </p>
          </div>
        ) : (
          compras.map((item) => (
            <CompraItem
              key={item.id}
              compra={item}
            />
          ))
        )}
      </div>
    </PageContainer>
  );
};